const registrationcsvcolumndata = [
  {
    id: "username",
    title: "Extension",
    default: true,
  },
  {
    id: "agent",
    title: "User Agent",
    default: true,
  },
  {
    id: "ip",
    title: "IP",
    default: true,
  },
  {
    id: "port",
    title: "Port",
    default: true,
  },
  {
    id: "pingtime",
    title: "Ping Time",
  },
  {
    id: "pingstatus",
    title: "Ping Status",
  },
  {
    id: "profile",
    title: "Profile",
    default: true,
  },
  {
    id: "status",
    title: "Status",
    default: true,
  },
];
export default registrationcsvcolumndata;
